import emojis from 'theme/emoji';

export const emojiImageObject = (emojiName: string, size?: number) => {
  const sizeValue = size ? size : 30;
  const imageObject = new Image(sizeValue, sizeValue);
  imageObject.src = emojis[emojiName].url;
  //retourne un format pour les chartsPoints de chart.js
  return imageObject;
};
